import {fadeIn, fadeOut} from "./utilities/fade";
import {changeRequiredAttributes} from "./order";
import {checkFilledInput, focusInputGroups} from "./checkInputGroups";
import {getScrollbarWidth} from "./utilities/functions";
import {addTableWrapper} from "./tableWrapper";
import {initSlidecontents} from "./slidecontent";
import EventHandler from "./dom/event-handler";

function showModalBackground() {

    if (document.querySelector('.modalBg') == null) {
        let modalbg = document.createElement('div');
        modalbg.classList.add('modalBg');
        document.body.appendChild(modalbg);
        document.body.classList.add('modal-open');

        if(window.outerWidth > GLOBALS.gridBreakpoints.sm) {
            document.body.style.paddingRight = getScrollbarWidth() + "px";
        }

        fadeIn(modalbg, 400);
        modalbg.addEventListener('click', function () {
            closeModal();
        });
    }
}

function removeModalBackground() {
    if (!document.querySelectorAll('.modal.open').length) {
        for (let modalbg of document.querySelectorAll('.modalBg')) {
            fadeOut(modalbg, 400, "linear", function () {
                modalbg.remove();
                document.body.classList.remove('modal-open');
                document.body.style.paddingRight = "";
            });
        }
    }
}

function resetModalStyles(modal) {
    modal.style.zIndex = "";
}

export function generateNewModal(templateID) {
    const template = document.getElementById(templateID);
    if (template) {
        const newModal = document.body.appendChild(template.content.cloneNode(true).querySelector('.modal'));
        newModal.setAttribute("id", "newModal");
        return newModal;
    } else {
        console.error("Cannot find Modal Template");

        return false;
    }
}

function disablePrevOpenedModals(modals,currentModal){
    for(let modal of modals){
        if(modal !== currentModal){
            modal.classList.add('modal--disabled');
        }
    }
}

function enableLastOpenedModal(){
    let allOpenedModals = document.querySelectorAll('.modal.open');
    if(allOpenedModals){
        let index = allOpenedModals.length - 1;
        if(index >= 0){
            for(let modal of allOpenedModals){
                if(parseInt(modal.dataset.index) === index){
                    modal.classList.remove("modal--disabled");
                }
            }
        }else{
            document.removeEventListener("keydown", eventEscapeCloseModal);
        }
    }
}

function eventEscapeCloseModal(event) {
    if(event.key === "Escape"){
        const allOpenedModals = document.querySelectorAll('.modal.open');
        closeModal(allOpenedModals[allOpenedModals.length - 1]);
    }
}

export function closeModal(modal = null) {
    let modals = [];
    if (modal === null) {
        modals = document.querySelectorAll('.modal');
    } else {
        modals.push(modal);
    }

    if (modals) {
        for (let modal of modals) {
            const triggerElement = modal._triggerElement || null;
            resetModalStyles(modal);
            modal.classList.remove('open');
            modal.classList.remove('show');
            let frames = modal.querySelectorAll('iframe,video');
            for (let frame of frames) {
                let src = frame.getAttribute('src');
                if (src) {
                    frame.setAttribute('src', '');
                    frame.setAttribute('src', src);
                }
            }
            enableLastOpenedModal();

            delete modal._triggerElement;

            setTimeout(function () {
                modal.style.display = "";
                removeModalBackground();
                if (triggerElement) {
                    triggerElement.focus();
                }
            }, 200);
        }
    }

    EventHandler.trigger(modal, 'hidden.modal');

}

export function showModal(modal, callback = () => {},options = {}) {
    if (modal) {
        // Fokus-Ursprung speichern (explizit gesetzter Auslöser hat Vorrang)
        if (!modal._triggerElement) {
            modal._triggerElement = document.activeElement;
        }

        let allOpenedModals = document.querySelectorAll('.modal.open');
        let index = allOpenedModals.length;


        let defaultOptions = {
            type: "modal",
            direction: ""
        };

        options = {...defaultOptions, ...options};

        if (options.type === 'flyout') {
            modal.classList.add('modal--flyout');
            if (options.direction === 'left') {
                modal.classList.add(`modal--flyoutLeft`);
            } else {
                modal.classList.add(`modal--flyoutRight`);
            }
        }

        modal.setAttribute('data-index', index);

        // ARIA: Dialog-Rolle und Label setzen
        const dialog = modal.querySelector('.modal__dialog');
        const titleEl = modal.querySelector('.modal__title');
        if (dialog) {
            dialog.setAttribute('role', 'dialog');
            dialog.setAttribute('aria-modal', 'true');
            if (!dialog.hasAttribute('tabindex')) {
                dialog.setAttribute('tabindex', '-1');
            }
            if (titleEl) {
                // aria-label (statischer String) statt aria-labelledby (DOM-Referenz).
                // aria-labelledby veranlasst VoiceOver, modal__title bei jeder
                // Interaktion im Dialog als Kontext-Präfix erneut vorzulesen.
                // aria-label wird einmalig aus dem Titeltext gelesen und nicht
                // bei DOM-Mutationen im Dialog neu ausgelöst.
                dialog.setAttribute('aria-label', titleEl.textContent.trim());
            }
        }

        // Schließ-Button: aria-label setzen, keyboard-zugänglich machen und ans Ende verschieben
        const closeBtn = modal.querySelector('.modal__close');
        const modalContent = modal.querySelector('.modal__content');
        if (closeBtn) {
            if (!closeBtn.hasAttribute('aria-label')) {
                closeBtn.setAttribute('aria-label', 'Modal schließen');
            }
            if (closeBtn.tagName !== 'BUTTON') {
                closeBtn.setAttribute('role', 'button');
                if (!closeBtn.hasAttribute('tabindex')) {
                    closeBtn.setAttribute('tabindex', '0');
                }
            }
            if (modalContent && getComputedStyle(closeBtn).position === 'absolute') {
                modalContent.appendChild(closeBtn);
            }
        }

        modal.style.display = "flex";
        showModalBackground();

        setTimeout(function () {
            disablePrevOpenedModals(allOpenedModals,modal);
            modal.classList.add('open');
            if (index > 0) {
                modal.style.zIndex = parseInt(getComputedStyle(modal).zIndex + index);
            }
            setTimeout(function (){
                changeRequiredAttributes(modal.querySelectorAll('.isRequiredVisible'));
            },200);
            focusInputGroups(modal.querySelectorAll('.inputGroup input,.inputGroup select,.inputGroup textarea'));
            callback();

            // Fokus auf erstes interaktives Element im Dialog setzen,
            // aber nur wenn der Nutzer nicht bereits ein Element darin fokussiert hat.
            // Verhindert Focus-Stealing wenn der Nutzer schneller interagiert
            // als der Timeout läuft.
            setTimeout(function () {
                if (!dialog) return;
                const active = document.activeElement;
                if (active && active !== document.body && active !== dialog && dialog.contains(active)) {
                    return;
                }
                // Auswahl-Dialoge (data-initial-focus="dialog") fokussieren den Dialog selbst,
                // damit beim automatischen Öffnen kein Fokusrahmen auf einer der Optionen liegt.
                if (modal.dataset.initialFocus === 'dialog') {
                    dialog.focus();
                    return;
                }
                const focusableSelectors = [
                    'input:not([type="hidden"]):not([disabled])',
                    'select:not([disabled])',
                    'textarea:not([disabled])',
                    'button:not([disabled])',
                    '[role="button"]:not([disabled])',
                    '[tabindex]:not([tabindex="-1"])'
                ].join(',');
                const firstFocusable = dialog.querySelector(focusableSelectors);
                if (firstFocusable) {
                    firstFocusable.focus();
                } else {
                    dialog.focus();
                }
            }, 200);
        }, 200);

        modal.addEventListener('mousedown', function (e) {
            if (e.target.closest(".modal__dialog") === null) {
                closeModal(modal);
            }
            if (e.target.closest("[data-close=\"modal\"]") !== null) {
                closeModal(modal);
            }
        });

        // Tastatur: Enter/Leertaste auf Schließen-Elementen lösen kein mousedown aus
        if (!modal._keyboardCloseBound) {
            modal._keyboardCloseBound = true;
            modal.addEventListener('click', function (e) {
                // detail === 0: per Tastatur ausgelöster Klick, Mausklicks schließen bereits über mousedown
                if (e.detail === 0 && e.target.closest("[data-close=\"modal\"]") !== null) {
                    closeModal(modal);
                }
            });
            modal.addEventListener('keydown', function (e) {
                if ((e.key === 'Enter' || e.key === ' ') && e.target.matches('[role="button"][data-close="modal"]')) {
                    e.preventDefault();
                    closeModal(modal);
                }
            });
        }

        if(index === 0){
            document.addEventListener("keydown", eventEscapeCloseModal);
        }
    }
}

export function triggerModal(query = document.querySelectorAll('[data-modal]')) {

    for (let modalTrigger of query) {
        modalTrigger.addEventListener('click', function (e) {
            const targetModal = document.getElementById(modalTrigger.dataset.modal);
            if (targetModal) {
                targetModal._triggerElement = modalTrigger;
            }
            showModal(targetModal);
            e.preventDefault();
        });
    }

    for (let openModalOnLoad of document.querySelectorAll('.modal--openOnLoad')) {
        showModal(openModalOnLoad);
    }
}

export function excludeModal(query = document.querySelectorAll('.modal:not(.modal-stay)')) {
    for (let modal of query) {
        document.body.append(modal);
    }
}

export function triggerOpenLinkInModal(cssselector = 'js-openLinkInModal') {
    document.addEventListener('click', function (e) {
        let target = false;
        if(e.target.classList.contains(cssselector)){
            target = e.target;
        }
        if(e.target.closest("a") && e.target.closest("a").classList.contains(cssselector)){
            target = e.target.closest("a");
        }
        if (target) {
            let modalTrigger = target;
            let href = modalTrigger.href;
            let title = modalTrigger.title;
            if (href) {
                const modal = generateNewModal("modalTemplate");
                if (modal) {
                    let modalClass = modalTrigger.dataset.modalClass;
                    if(modalClass){
                        modal.classList.add(modalClass);
                    }
                    showModal(modal);
                    fetch(modalTrigger.href)
                        .then((response) => {
                            if (!response.ok) {
                                throw "Could not load content";
                            }
                            return response.text();
                        })
                        .then((data) => {
                            let doc = new DOMParser().parseFromString(data, "text/html");
                            let contents = doc.querySelectorAll(".loadContentInModal");
                            let modalBody = modal.querySelector('.modal__body');
                            let modalTitle = modal.querySelector('.modal__title');
                            if (modalTitle) {
                                if (title) {
                                    modalTitle.innerHTML = title;
                                } else {
                                    modalTitle.closest('.modal__header')?.classList.add('modal__header--noTitle');
                                    modalTitle.remove();
                                }
                            }
                            if (contents && modalBody) {
                                modal.classList.remove("modal--loading");
                                modalBody.innerHTML = "";
                                for (let content of contents) {
                                    modalBody.innerHTML = modalBody.innerHTML + content.innerHTML;
                                }

                                focusInputGroups(modalBody.querySelectorAll('.inputGroup input,.inputGroup select,.inputGroup textarea'));
                                addTableWrapper(modalBody.querySelectorAll('.textcontent table, .modal__body table, .slidecontent table'));
                                initSlidecontents(modalBody.querySelectorAll('.slidecontentItem__headline'));
                            } else {
                                window.location.href = href;
                            }
                        })
                        .catch((e) => {
                            console.error('Error:', e);
                        });
                    e.preventDefault();
                }
            }
        }
    });
}

export function triggerConfirmModalLink(cssselector = 'js-confirmModalLink') {
    document.addEventListener('click', function (e) {
        let target = false;

        // check ob Button oder Link selbst das Ziel ist
        if (e.target.classList.contains(cssselector)) {
            target = e.target;
        }

        // falls ein verschachteltes Element im Link/Button geklickt wurde
        if (!target && e.target.closest("." + cssselector)) {
            target = e.target.closest("." + cssselector);
        }

        if (target) {
            e.preventDefault(); // Standardaktion immer erstmal verhindern

            if (target.dataset.modalOpen) {
                return;
            }

            let modalTrigger = target;
            let href = modalTrigger.href;
            let text = modalTrigger.dataset.text;
            let confirmBtnText = modalTrigger.dataset.confirmBtn;
            let confirmBtnClass = modalTrigger.dataset.confirmBtnClass;

            const modal = generateNewModal("confirmModalTemplate");
            if (modal) {
                target.dataset.modalOpen = '1';
                EventHandler.on(modal, 'hidden.modal', function () {
                    delete target.dataset.modalOpen;
                });

                let modalBody = modal.querySelector('.modal__body');
                let modalConfirmBtn = modal.querySelector('.js-confirmModalButton');

                if (modalBody && text) {
                    modalBody.innerHTML = text;
                }
                if (modalConfirmBtn && confirmBtnText) {
                    modalConfirmBtn.innerText = confirmBtnText;
                    if (confirmBtnClass) {
                        modalConfirmBtn.classList.remove("button--primary");
                        modalConfirmBtn.classList.add(confirmBtnClass);
                    }

                    modalConfirmBtn.addEventListener("click", function () {
                        // Prüfen ob Button in einem Formular steckt
                        if (modalTrigger.tagName.toLowerCase() === "button" && modalTrigger.type === "submit") {
                            const form = modalTrigger.closest("form");
                            if (form) {
                                form.submit(); // Formular absenden
                            }
                        } else if (href) {
                            // ansonsten klassisch Link-Weiterleitung
                            window.location.href = href;
                        }
                    });
                }

                showModal(modal);
            }
        }
    });
}


export function triggerConfirmModalLinkOLD(cssselector = 'js-confirmModalLink') {
    document.addEventListener('click', function (e) {
        let target = false;
        if(e.target.classList.contains(cssselector)){
            target = e.target;
        }
        if(e.target.closest("a") && e.target.closest("a").classList.contains(cssselector)){
            target = e.target.closest("a");
        }
        if (target) {
            let modalTrigger = target;
            let href = modalTrigger.href;
            let text = modalTrigger.dataset.text;
            let confirmBtnText = modalTrigger.dataset.confirmBtn;
            let confirmBtnClass = modalTrigger.dataset.confirmBtnClass;
            if (href) {
                const modal = generateNewModal("confirmModalTemplate");
                if (modal) {
                    let modalBody = modal.querySelector('.modal__body');
                    let modalConfirmBtn = modal.querySelector('.js-confirmModalButton');
                    if (modalBody && text) {
                        modalBody.innerHTML = text;
                    }
                    if (modalConfirmBtn && confirmBtnText) {
                        modalConfirmBtn.innerText = confirmBtnText;
                        if (confirmBtnClass) {
                            modalConfirmBtn.classList.remove("button--primary");
                            modalConfirmBtn.classList.add(confirmBtnClass);
                        }

                        modalConfirmBtn.addEventListener("click", function () {
                            console.log(href);
                            window.location.href = href;
                        });
                    }
                    showModal(modal);
                    e.preventDefault();
                }
            }
        }
    });
}

export function triggerOpenTextInModal(cssselector = 'js-openTextInModal') {
    document.addEventListener('click', function (e) {
        let target = false;
        if(e.target.classList.contains(cssselector)){
            target = e.target;
        }
        if(e.target.closest("a") && e.target.closest("a").classList.contains(cssselector)){
            target = e.target.closest("a");
        }
        if (target) {
            let modalTrigger = target;
            let text = "no text";
            let title = "";

            if(modalTrigger.dataset.text){
                text = modalTrigger.dataset.text;
            }

            if(modalTrigger.dataset.headline){
                title = modalTrigger.dataset.headline;
            }
            const modal = generateNewModal("modalTemplate");
            if (modal) {
                modal.classList.remove("modal--loading");
                let modalClass = modalTrigger.dataset.modalClass;
                if(modalClass){
                    modal.classList.add(modalClass);
                }
                let modalBody = modal.querySelector('.modal__body');
                let modalTitle = modal.querySelector('.modal__title');
                if (modalTitle) {
                    modalTitle.innerHTML = title;
                }
                if (modalBody) {
                    modalBody.innerHTML = "<div>"+text+"</div>";
                }
                showModal(modal);
                e.preventDefault();
            }
        }
    });
}